/** Maps API / English probability & impact scale strings to riskOverview.levels.* i18n keys. */

export const PROBABILITY_WEIGHTS = {
    rare: 1,
    unlikely: 2,
    possible: 3,
    likely: 4,
    almostcertain: 5,
};

export function probabilityWeight(scale) {
    const key = String(scale || '').trim().toLowerCase().replace(/\s+/g, '');
    return PROBABILITY_WEIGHTS[key] ?? 0;
}

/** Sort probability rows/options low → high (Nadir … Neredeyse Kesin). */
export function sortProbabilityScales(items) {
    return [...items].sort(
        (a, b) => probabilityWeight(a.scale ?? a.value) - probabilityWeight(b.scale ?? b.value)
    );
}

export function translateRiskProbability(scale, t) {
    const s = String(scale || '').trim().toLowerCase();
    const compact = s.replace(/\s+/g, '');
    let key = null;
    if (compact === 'almostcertain' || s === 'almost certain') key = 'almostCertain';
    else if (['rare', 'unlikely', 'possible', 'likely'].includes(compact)) key = compact;
    return key ? t(`riskOverview.levels.probability.${key}`) : scale;
}

export function translateRiskImpact(impact, t) {
    const s = String(impact || '').trim().toLowerCase();
    let key = null;
    if (s === 'catastrophe' || s === 'catastrophic') key = 'catastrophic';
    else if (['insignificant', 'minor', 'moderate', 'major'].includes(s)) key = s;
    return key ? t(`riskOverview.levels.impact.${key}`) : impact;
}
